export class ListSavedQueriesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "savedQueries",
            "baseName": "savedQueries",
            "type": "Array<SavedQuery>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSavedQueriesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
